
(function(template){
    define('vue!app/views/vue/components/cartComponent/popupLoginComponent/container',['Vue','vue!./componentPopUp'],function(Vue,componentPopUp){
        return {
            template:template,
            components: {
                'component-pop-up' : componentPopUp,
            },
            methods: {
                handleKeyDown: function(e) {
                    this.a11yKeyDown(e,{
                        enter: function(){
                            $('.content-spaPackageTpl #vue-cart .componentHeader .sidebar_switch input').click();
                        }
                    })
                },
                toggleCheckbox: function() {
                    this.$store.commit(
                        "setshowSummaryOnSideBar",
                        !this.$store.state.showSummaryOnSideBar
                    );
                },
            }
        }
    })
})('<div class="componentHeader"> <div class="header"> <span>{{localStrings.sideCart.cart}}</span> <span v-if="customization.showSideCartViewToggle"> <label class="sidebar_switch"> <input type="checkbox" tabindex="-1" @click="toggleCheckbox" /> <span tabindex="0" @keydown="handleKeyDown" class="sidebar_slider round"></span> </label> <strong>{{localStrings.sideCart.itinerary}}</strong> </span> </div> <component-pop-up></component-pop-up> </div>');
